import React from 'react';
import './loader.css';

const Loader = ({ isLoading = true, text = null, showOnlyBackdrop = false }) => {
    if (!isLoading) return null;

    return (
        <div className="loader-overlay">
            {
                !showOnlyBackdrop && <>
                    <div className="loader-spinner" style={{ animationDelay: '0s' }}></div>
                    <div className="loader-spinner" style={{ animationDelay: '0.3s' }}></div>
                    <div className="loader-spinner" style={{ animationDelay: '0.4s' }}></div>
                    {/* {text && <div className='glow-text-only'>{text} <i className="bi bi-stars text-warning"></i></div>} */}
                </>
            }

        </div>
    );
};

export default Loader;
